import ImageWithFallback from '../../common/image-with-fallback';
import GroupWhite2020 from '@svg/main/trip-card/group_white_20_20.svg';
import SharePrimary1818 from '@svg/main/trip-card/share_primary_18_18.svg';
import TrashCan1818 from '@svg/main/trip-card/trash_can_18_18.svg';

interface TripHeaderProps {
  title: string;
  mainImageUrl: string;
  tripDate: string;
  isCoSurvey: boolean;
  onShare: (e: React.MouseEvent) => void;
  onDelete: (e: React.MouseEvent) => void;
}

export default function TripHeader({ title, mainImageUrl, tripDate, isCoSurvey, onShare, onDelete }: TripHeaderProps) {
  return (
    <div className='w-full flex'>
      <div className='relative flex flex-1 img-name-date gap-16pxr'>
        <div className='relative w-67pxr h-67pxr'>
          <ImageWithFallback
            src={mainImageUrl}
            className='relative rounded-6pxr w-67pxr h-67pxr skeleton-item'
            alt='city'
            width={67}
            height={67}
            fallbackSrc='https://hoolzzuk-public-images.s3.ap-northeast-2.amazonaws.com/cities/square_128x128.png'
          />
          {isCoSurvey && <GroupWhite2020 className='absolute bottom-4pxr right-4pxr' />}
        </div>
        <div className='flex flex-col items-start'>
          <div className='text-gray-800 break-all sub-heading-16-m line-clamp-2'>{title}</div>
          <p className='text-gray-600 body-14-r mt-4pxr'>{tripDate}</p>
        </div>
      </div>

      <div className='flex flex-row gap-4pxr items-start'>
        <span className='p-1pxr' onClick={onShare}>
          <SharePrimary1818 className='flex-none' />
        </span>
        <span className='p-1pxr' onClick={onDelete}>
          <TrashCan1818 className='flex-none' />
        </span>
      </div>
    </div>
  );
}
